"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBarContainer = void 0;
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
require("./progress-bar.less");
let ProgressBarContainer = class ProgressBarContainer extends React.Component {
    constructor() {
        super(...arguments);
        this.progressPercentage = this.props.percentage;
    }
    componentDidUpdate() {
        this.progressPercentage = this.props.percentage;
    }
    render() {
        return (React.createElement("div", { className: this.props.className },
            React.createElement("h3", null, this.props.title),
            React.createElement("p", null, this.props.message),
            React.createElement(ProgressBar, { percentage: this.progressPercentage })));
    }
};
__decorate([
    mobx_1.observable
], ProgressBarContainer.prototype, "progressPercentage", void 0);
ProgressBarContainer = __decorate([
    mobx_react_1.observer
], ProgressBarContainer);
exports.ProgressBarContainer = ProgressBarContainer;
const ProgressBar = (props) => (React.createElement("div", { className: "progress-bar" },
    React.createElement(Filler, { percentage: props.percentage })));
const Filler = (props) => (React.createElement("div", { className: "filler", style: { width: `${props.percentage}%` } }));



//////////////////
// WEBPACK FOOTER
// ./src/client/components/progress-bar/progress-bar.tsx
// module id = 3826
// module chunks = 0